export default __webpack_public_path__ + "static/media/f.913b1f74.svg";